import {PeriodSchema} from '@/types/Period'
import {z} from 'zod'
import {NodeTypeEnum} from './NodeTypeEnum'

const ExecutionStatusType = {
  created: 'CREATED',
  running: 'RUNNING',
  completed: 'COMPLETED',
  canceled: 'CANCELED',
} as const

const StepStatusType = {
  created: 'CREATED',
  running: 'RUNNING',
  onHold: 'ON_HOLD',
  skipped: 'SKIPPED',
  failed: 'FAILED',
  executed: 'EXECUTED',
  canceled: 'CANCELED',
  interrupted: 'INTERRUPTED',
} as const

const ExecutionStatusTypesSchema = z.nativeEnum(ExecutionStatusType).or(z.nativeEnum(StepStatusType))
export type ExecutionStatusTypes = z.infer<typeof ExecutionStatusTypesSchema>

const ExecutionStatusSchema = z.record(ExecutionStatusTypesSchema, z.number())
export type ExecutionStatus = z.infer<typeof ExecutionStatusSchema>

const StepStatusSchema = z.record(z.nativeEnum(StepStatusType), z.number())

const StepExecutionStatusSchema = z.record(
  z.object({
    id: z.string(),
    type: z.nativeEnum(NodeTypeEnum),
    status: StepStatusSchema,
  })
)

const JourneyExecutionStatusSchema = z.object({
  journey: z
    .object({
      id: z.string(),
    })
    .optional(),
  period: PeriodSchema.optional(),
  executions: z.object({
    total: z.number(),
    status: ExecutionStatusSchema,
    steps: StepExecutionStatusSchema,
  }),
})
export type JourneyExecutionStatus = z.infer<typeof JourneyExecutionStatusSchema>

// MARK: - Single Journey execution status

export const GetJourneyStatusRequestSchema = z.void()
export const GetJourneyStatusResponseSchema = JourneyExecutionStatusSchema

export type GetJourneyStatusRequest = z.infer<typeof GetJourneyStatusRequestSchema>
export type GetJourneyStatusResponse = z.infer<typeof GetJourneyStatusResponseSchema>
